import React from 'react';
import classNames from 'classnames';
import {
	AssignmentType,
	AssignmentStatus
} from 'LearningManager/constants/CoursesAssignment.types';
import styles from './AssignmentBadge.module.scss';

export type AssignmentBadgeType =
	| AssignmentType
	| AssignmentStatus
	| 'Required'
	| 'Optional';

interface AssignmentBadgeProps {
	type: string;
	className?: string;
}

const TYPE_CLASS: Record<string, string> = {
	'One-Time': styles['badge--oneTime'],
	Ongoing: styles['badge--ongoing'],
	Scheduled: styles['badge--scheduled'],
	Active: styles['badge--active'],
	Completed: styles['badge--completed'],
	Required: styles['badge--scheduled'],
	Optional: styles['badge--scheduled'],
	'In Progress': styles['badge--ongoing'],
	Complete: styles['badge--completed']
};

const AssignmentBadge: React.FC<AssignmentBadgeProps> = ({
	type,
	className
}) => (
	<span className={classNames(styles.badge, TYPE_CLASS[type], className)}>
		{type}
	</span>
);

export default AssignmentBadge;
